import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/dashboard";

export const dashboard = {
    // ...example,
    get(){
        return axios.get(`${url}`).then(result => result.data);
    },
}
